import { fetchGroupPaydatesQuery } from "api/useQueryCalls";
import GroupPayTable from "atoms/GroupPayTable";
import NoData from "atoms/NoData";
import SummaryBox from "atoms/SummaryBox";
import PaginationMui from "molecules/Pagination";
import { Box, useToast } from "native-base";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getStore } from "store/storeUtils";
import AmplitudeHelper from "utils/analytics";
import { AMPLITUDE_EVENTSOURCES } from "utils/analytics/constants";
import { showErrorToast } from "utils/utilities";

function renderTable(data, isLoading, currentPage, setCurrentPage, PAGE_LIMIT) {
  if (data?.data?.length === 0) return <NoData />;
  return (
    <>
      <GroupPayTable data={data?.data} loading={isLoading} currentPage={currentPage} />
      <PaginationMui
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPageNumber={data?.count ? Math.ceil(data.count / PAGE_LIMIT) : 0}
      />
    </>
  );
}

const GroupPayDateInfo = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { resetLoginData } = getStore();
  const PAGE_LIMIT = 50;
  const { isLoading, isError, error, data } = fetchGroupPaydatesQuery({
    skip: (currentPage - 1) * PAGE_LIMIT,
    limit: PAGE_LIMIT,
  });
  const toast = useToast();

  useEffect(() => {
    if (isError) showErrorToast({ error, toast, navigate, resetLoginData });
  }, [isError, error]);

  useEffect(() => {
    AmplitudeHelper.logEvent(AMPLITUDE_EVENTSOURCES.groupAndpaydate_page);
  }, []);

  return (
    <Box
      style={{
        marginTop: 8,
      }}
      testID="groupPayDateInfo"
    >
      <SummaryBox title={t("groupPaydate.tableText")}>
        {renderTable(data, isLoading, currentPage, setCurrentPage, PAGE_LIMIT)}
      </SummaryBox>
    </Box>
  );
};

export default GroupPayDateInfo;
